import { render, staticRenderFns } from "./SystemLog.vue?vue&type=template&id=8b1aabc2&scoped=true&"
import script from "./SystemLog.vue?vue&type=script&lang=js&"
export * from "./SystemLog.vue?vue&type=script&lang=js&"
import style0 from "./SystemLog.vue?vue&type=style&index=0&id=8b1aabc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1aabc2",
  null
  
)

export default component.exports